<template>
  <div class="activity-box">
    <img :src="bg" alt="" />
  </div>
</template>
<script>
import bg from './images/bg.jpg';
export default {
  name: 'Constellation',
  data() {
    return {
      bg
    };
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #160f3a;
  img {
    width: auto;
    height: 100%;
  }
}
</style>
